import React from 'react';

export default function CoolingTower3Icon({
  width = 64,
  height = 53,
  startColor = '#735940',
  midColor = '#E5CBB2',
  endColor = '#735940'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 93.917" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Cooling_Tower">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="5.1812" y1="88.0718" x2="107.2061" y2="88.0718">
		<stop offset="0.01" style={{stopColor: "#997F66"}} />
		<stop offset="0.5" style={{stopColor: "#CCB299"}} />
		<stop offset="1" style={{stopColor: "#997F66"}} />
	</linearGradient>
	<ellipse fill={`url(#${id}_1_)`} cx="56.194" cy="88.073" rx="51.012" ry="5.281" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="0.5645" y1="5.479" x2="111.8145" y2="5.479">
		<stop offset="0.01" style={{stopColor: "#997F66"}} />
		<stop offset="0.5" style={{stopColor: "#CCB299"}} />
		<stop offset="1" style={{stopColor: "#997F66"}} />
	</linearGradient>
	<ellipse fill={`url(#${id}_2_)`} cx="56.189" cy="5.48" rx="55.625" ry="5.48" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="0.5151" y1="46.8462" x2="112.002" y2="46.8462">
		<stop offset="0.01" style={{stopColor: "#997F66"}} />
		<stop offset="0.5" style={{stopColor: "#CCB299"}} />
		<stop offset="1" style={{stopColor: "#997F66"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M107.271,88.738v-30.18l4.73-53.377l-0.113-0.226L0.515,5.181l4.729,53.377v29.531   c0.134,0.01,0.268,0.068,0.402,0.203" />
</g>
<g id="Group_Upper_Tower">
	<path fill="#A68C73" d="M86.373,5.743l9.234,45.833l8.671-44.144L86.373,5.743z" />
	<path fill="#A68C73" d="M26.014,5.743L16.78,51.576L8.109,7.432L26.014,5.743z" />
	<path fill="#8C7259" d="M110.134,24.887l-2.928-13.288l-9.233,44.594h9.233L110.134,24.887z" />
	<path fill="#8C7259" d="M2.479,24.774l2.703-13.176l9.234,44.594H5.294L2.479,24.774z" />
	<path fill="#735940" d="M2.479,24.662l2.703-13.063l1.126,5.743L2.929,31.418L2.479,24.662z" />
	<path fill="#735940" d="M110.134,24.887l-2.928-13.288l-1.126,5.743l3.49,14.527L110.134,24.887z" />
	<path fill="#CCB299" d="M95.607,51.576l8.671-44.144l-2.253,1.802l-6.981,38.287L95.607,51.576z" />
	<path fill="#CCB299" d="M16.78,51.576L8.109,7.432l2.252,1.802l6.982,38.287L16.78,51.576z" />
	<path fill="#BFA58C" d="M60.811,5.18l9.347,46.396L79.392,5.18H60.811z" />
	<path fill="#BFA58C" d="M46.959,56.193l9.234-46.396l9.234,46.396H46.959z" />
	<path fill="#BFA58C" d="M51.577,5.18L42.23,51.576L32.996,5.18H51.577z" />
	<path fill="#B2987F" d="M92.116,56.193L82.883,9.797l-9.234,46.396H92.116z" />
	<path fill="#B2987F" d="M20.271,56.193l9.234-46.396l9.234,46.396H20.271z" />
	<path fill="#997F66" d="M79.392,5.18H60.811l0.563,2.252h16.329L79.392,5.18z" />
	<path fill="#997F66" d="M32.996,5.18h18.581l-0.563,2.252H34.685L32.996,5.18z" />
	<path fill="#997F66" d="M46.959,56.193l9.234-46.396l9.234,46.396l-1.126-0.563l-8.108-40.54l-8.108,40.54L46.959,56.193z" />
	<path fill="#7F654C" d="M92.116,56.193L82.883,9.797l-9.234,46.396h0.563l8.108-40.54l8.108,39.977L92.116,56.193z" />
	<path fill="#7F654C" d="M20.271,56.193l9.234-46.396l9.234,46.396l-0.563-0.563l-8.108-39.977L21.96,55.629L20.271,56.193z" />
	<path fill="#7F654C" d="M104.391,7.432L86.373,5.743l0.563,2.365l15.09,1.126L104.391,7.432z" />
	<path fill="#7F654C" d="M7.997,7.432l18.018-1.689l-0.563,2.365l-15.09,1.126L7.997,7.432z" />
	<path fill="#E5CBB2" d="M46.959,56.193h18.468l-1.126-0.563H48.086L46.959,56.193z" />
	<path fill="#CCB299" d="M73.648,56.193h18.468l-1.688-0.563H74.211L73.648,56.193z" />
	<path fill="#B2987F" d="M97.973,56.193h9.233v-0.563h-9.233V56.193z" />
	<path fill="#CCB299" d="M20.271,56.193h18.468l-0.563-0.563H21.96L20.271,56.193z" />
	<path fill="#B2987F" d="M5.181,56.193h9.234v-0.563H5.181V56.193z" />
	<path fill="#E5CBB2" d="M70.157,51.576L79.392,5.18l-1.689,2.252l-8.221,40.652L70.157,51.576z" />
	<path fill="#E5CBB2" d="M42.23,51.576L32.996,5.18l1.689,2.252l8.221,40.652L42.23,51.576z" />
</g>
<g id="Group_Lower_Vaccum">
	<path fill="#A68C73" d="M85.811,86.935l9.233-20.27l9.347,19.144L85.811,86.935z" />
	<path fill="#A68C73" d="M7.997,85.809l9.347-19.144l9.234,20.27L7.997,85.809z" />
	<path fill="#8C7259" d="M107.206,63.174V84.12l-9.233-20.945H107.206z" />
	<path fill="#8C7259" d="M14.416,63.174L5.181,84.12V63.174H14.416z" />
	<path fill="#735940" d="M5.181,65.539h8.108l1.126-2.364H5.181V65.539z" />
	<path fill="#735940" d="M99.098,65.539h8.108v-2.364h-9.233L99.098,65.539z" />
	<path fill="#BFA58C" d="M65.428,63.174L56.194,84.12l-9.234-20.945H65.428z" />
	<path fill="#B2987F" d="M92.116,63.174L82.883,84.12l-9.234-20.945H92.116z" />
	<path fill="#B2987F" d="M38.739,63.174L29.505,84.12l-9.234-20.945H38.739z" />
	<path fill="#B2987F" d="M60.248,88.737l9.233-20.946l9.347,20.383L60.248,88.737z" />
	<path fill="#B2987F" d="M33.559,88.173l9.347-20.383l9.234,20.946L33.559,88.173z" />
	<path fill="#997F66" d="M48.086,65.539h16.216l1.126-2.364H46.959L48.086,65.539z" />
	<path fill="#997F66" d="M48.649,65.539h15.089l1.689-2.364H46.959L48.649,65.539z" />
	<path fill="#7F654C" d="M22.523,65.539h15.09l1.126-2.364H20.271L22.523,65.539z" />
	<path fill="#7F654C" d="M74.774,65.539h15.09l2.252-2.364H73.648L74.774,65.539z" />
	<path fill="#E5CBB2" d="M63.738,65.539L56.194,82.88l-7.545-17.342l-1.689-2.364l9.234,20.945l9.234-20.945L63.738,65.539z" />
	<path fill="#E5CBB2" d="M60.248,88.737l18.58-0.563l-1.126-0.563H60.811L60.248,88.737z" />
	<path fill="#E5CBB2" d="M52.14,88.737l-18.581-0.563l1.126-0.563h16.892L52.14,88.737z" />
	<path fill="#CCB299" d="M89.864,65.539l-7.545,16.779l0.563,1.802l9.233-20.945L89.864,65.539z" />
	<path fill="#CCB299" d="M30.068,82.318l-7.545-16.779l-2.252-2.364l9.234,20.945L30.068,82.318z" />
	<path fill="#7F654C" d="M69.031,69.03l8.671,18.581l1.126,0.563l-9.347-20.383L69.031,69.03z" />
	<path fill="#7F654C" d="M34.685,87.611l8.784-18.581l-0.563-1.239l-9.347,20.383L34.685,87.611z" />
	<path fill="#CCB299" d="M85.811,86.935l18.58-1.126l-1.802-0.563l-16.216,0.563L85.811,86.935z" />
	<path fill="#CCB299" d="M26.577,86.935L7.997,85.809l1.802-0.563l16.216,0.563L26.577,86.935z" />
	<path fill="#735940" d="M95.044,66.666l9.347,19.144l-1.802-0.563L94.48,67.791L95.044,66.666z" />
	<path fill="#735940" d="M17.343,66.666L7.997,85.809l1.802-0.563l8.108-16.891L17.343,66.666z" />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="93.917" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
